import React from 'react';
import { Link } from 'react-router-dom';

const DefaultButton = ({ children, to, onClick, className = '' }) => {
  const baseStyles = `rounded-xl text-md font-medium border border-orange-400 bg-gray-800 text-white px-5 py-3 hover:bg-gray-700 transition-all duration-200 hover:bg-orange-400 hover:text-black${className}`;

  if (to) {
    return (
      <Link to={to} className={baseStyles}>
        {children}
      </Link>
    );
  }

  return (
    <button type = "button" onClick={onClick} className={baseStyles}>
      {children}
    </button>
  );
};

export default DefaultButton;
